import { createAction, props } from '@ngrx/store';
import { TableColumn } from '../../../core/interfaces/dynamic-table';
import { CommonListConfig } from "../page-configs.helper";

export class DocumentInfoActions {
    static readonly loadDocumentInfo = createAction('[Document Info] Loading');
    static readonly loadDocumentInfoSuccess = createAction('[Document Info] Success', props<{ data: CommonListConfig }>());
    static readonly loadDocumentInfoFailure = createAction('[Document Info] Failure', props<{ error: any }>());
}
